module.exports = __webpack_public_path__ + "../static/media/formato1.722faf9a.jpg";